"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAppendToElement = void 0;
var utils_1 = require("./utils");
var isElement = require('lodash/isElement');
function getAppendToElement(appendTo, node) {
    if (!appendTo) {
        return null;
    }
    if (typeof appendTo === 'string') {
        switch (appendTo) {
            case 'window':
            case 'viewport':
                return document.body;
            case 'scrollParent':
                return utils_1.getScrollParent(node);
            default:
                return;
        }
    }
    if (typeof appendTo === 'function') {
        return getByPredicate(appendTo, node);
    }
    if (isElement(appendTo)) {
        return appendTo;
    }
    return;
}
exports.getAppendToElement = getAppendToElement;
function getByPredicate(predicate, element) {
    if (!element) {
        return;
    }
    var node = searchParent(predicate, element);
    if (node) {
        return node;
    }
    return;
}
function searchParent(predicate, element) {
    if (!element) {
        return;
    }
    if (predicate(element)) {
        return element;
    }
    return searchParent(predicate, utils_1.getParentNode(element));
}
//# sourceMappingURL=getAppendToElement.js.map